// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"e4fc4f79","373":"e4fc4f79","555":"e4fc4f79","705":"e4fc4f79","707":"e4fc4f79","730":"e4fc4f79","849":"e4fc4f79","984":"e4fc4f79"}[chunkId] + ".chunk.css";
};